import React from 'react';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('documento');
    navigate('/login');
  };

  return (
    <nav className="bg-neutral-900 text-white p-4 shadow-md">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <img 
            src={`${process.env.PUBLIC_URL}/lgo-udi-blanco.png`}
            alt="UDI Logo" 
            className="h-8 mr-3"
          />
          <span className="text-lg font-semibold">Revisión de Matrícula</span>
        </div>
        <button
          onClick={handleLogout}
          className="px-3 py-1.5 text-sm bg-white text-neutral-950 rounded hover:bg-neutral-200 transition-colors"
        >
          Cerrar Sesión
        </button>
      </div>
    </nav>
  );
};

export default Navbar;